// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, AUTHED_FLAG, errMsg } from "../api";
import { useAuth } from "../AuthContext";

export default function AuthCallback() {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const [error, setError] = useState("");

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
        if (!sid) {
            navigate("/login", { replace: true });
            return;
        }
        api.post("/auth/emergent/session", { session_id: sid })
            .then(async ({ data }) => {
                sessionStorage.setItem(AUTHED_FLAG, "1");
                localStorage.setItem(AUTHED_FLAG, "1");
                window.history.replaceState(null, "", window.location.pathname);
                await refresh();
                navigate(data.user?.role === "admin" ? "/admin" : "/account", { replace: true });
            })
            .catch((e) => setError(errMsg(e)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen grid place-items-center px-6" data-testid="auth-callback">
            <div className="card-glass p-10 text-center max-w-sm w-full" style={{ borderRadius: 22 }}>
                {error ? (
                    <>
                        <div className="font-serif text-xl text-[var(--ink)] mb-2">Sign-in failed</div>
                        <p className="text-[13px] text-[var(--body)] mb-5" data-testid="auth-callback-error">{error}</p>
                        <Link to="/login" className="btn btn-primary" data-testid="auth-callback-retry">Back to login</Link>
                    </>
                ) : (
                    <>
                        <div className="w-10 h-10 mx-auto mb-4 rounded-full border-2 border-[var(--taupe)] border-t-transparent animate-spin" />
                        <div className="font-serif text-xl text-[var(--ink)]">Signing you in…</div>
                        <p className="text-[13px] text-[var(--body)] mt-1">Connecting your Google account</p>
                    </>
                )}
            </div>
        </div>
    );
}
